const Search = ({ handleSearch, value }) => {
    return (
        <div className="relative w-full sm:w-52">
            <input
                type="text"
                value={value}
                onChange={handleSearch}
                placeholder="Search your library…"
                className="pl-8 pr-4 py-1.5 text-sm bg-white border border-warm-200 rounded-lg text-warm-800 placeholder-warm-300 focus:outline-none focus:ring-2 focus:ring-warm-300 transition w-full"
            />
            <svg
                className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-warm-300"
                fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
        </div>
    );
};

export default Search;
